import React from "react";
import { EditField } from "../types";
import colors from "../../../colors/colors";

interface ToggleFieldProps {
  value: boolean;
  onChange: (value: boolean) => void;
  field: EditField;
}

export const ToggleField: React.FC<ToggleFieldProps> = ({ value, onChange }) => {
  const isChecked = Boolean(value);
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      onClick={() => onChange(!isChecked)}
      className="edit-panel-toggle"
      style={{
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: isChecked ? colors.blue : colors.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: isChecked ? "flex-end" : "flex-start",
      }}
    >
      <span
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "12px",
          background: colors.white,
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
          transition: "all 0.2s ease",
        }}
      />
    </button>
  );
};

